export default "__VITE_ASSET__DOaughF7__"